import React, { useRef } from 'react';
import { buildSvgEvents } from './svgCommonEvents';
import PropTypes from 'prop-types';

const IconRestore = ({
    disabled = false,
    onClick,
    fill,
    size = 50,
    style,
    ...props
}) => {
    const ref = useRef(null);

    return (
        <svg
            ref={ref}
            height={size * 1.26}
            fill={disabled ? '#cccccc' : fill}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 33.66 50'
            style={{
                cursor: disabled ? 'default' : 'pointer',
                ...style
            }}
            {...buildSvgEvents(ref, disabled, onClick, fill)}
            {...props}
        >
            <g strokeWidth={0.664}>
                <path
                    d='M41.81,19.44,14,19.5C21.71,14.4,38.09,3.6,38.09,3.6L36.5,1.19l-1.28.7c-.15-.2-.29-.35-.4-.51C33.67-.26,33.35-.36,31.67.68c-1.5.93-3,1.94-4.48,2.94l-.54-.73a5.45,5.45,0,0,0-7.54-1.38,45.05,45.05,0,0,1-3.86,2.54c-1.51.88-2.77,3.94-2,5.73l1,2.43c-1.61,1.06-3.27,2.14-4.91,3.25-1,.68-1.08,1.18-.44,2.22s.69,1.16-.21,1.83H8.15v2.77a20.32,20.32,0,0,0,2.15.08c.8-.06,1,.24,1,1,0,7.39.08,14.79,0,22.18A4.92,4.92,0,0,0,15.56,50q9.42-.09,18.86,0c2.17,0,4.35-2.43,4.33-4.45-.08-7.37,0-14.73,0-22.09,0-.35,0-.69,0-1.14h3.08ZM17.07,6.58c1.16-.82,2.41-1.52,3.54-2.38a2.35,2.35,0,0,1,3.78,1.19L17,10.26A2.25,2.25,0,0,1,17.07,6.58ZM35.72,45.06c0,1.57-.44,2-2,2H16c-1.19,0-1.78-.54-1.79-1.72,0-7.51,0-15-.05-22.53a2.66,2.66,0,0,1,.07-.38c.33,0,.62,0,.91,0,6.56,0,13.12,0,19.67,0,.85,0,1,.27,1,1.06C35.77,30.63,35.75,37.84,35.72,45.06Z'
                    transform='translate(-8.15 0)'
                />
                <polygon points='16.24 25.82 9.9 32.17 13.57 32.17 13.57 43.79 18.91 43.79 18.91 32.17 22.58 32.17 16.24 25.82' />
            </g>
        </svg>
    );
};

IconRestore.defaultProps = {
    disabled: false,
    size: 50
};

IconRestore.propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    size: PropTypes.any,
    style: PropTypes.object,
    fill: PropTypes.any
};

export default IconRestore;
